const items = [
  "ESTOQUE SELECTED",
  "FINANCIAMENTO EM SEGUNDOS",
  "CRM + ERP INTEGRADOS",
  "IA NO WHATSAPP 24/7",
  "PROCEDÊNCIA GARANTIDA",
  "ENTREGA EM TODO O BRASIL",
];

export const Marquee = () => (
  <div className="relative py-6 border-y border-slate-800/60 bg-[#0d0f17] overflow-hidden" data-testid="editorial-marquee">
    <div className="flex whitespace-nowrap animate-marquee w-max">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display text-lg sm:text-xl font-semibold tracking-[0.2em] text-slate-500 px-8">
            {item}
          </span>
          <span className="w-2 h-2 rounded-full bg-emerald-500/60" />
        </span>
      ))}
    </div>
  </div>
);
